export default __webpack_public_path__ + "static/2-b8cfd76e012b816cdd499ad6a4275715.png";